module.exports = __webpack_public_path__ + "img/3.c739f739.png";